import { skillsT } from "../../assets/icons/getIcons";
import "./_skills.scss";

function Skills() {


  return (
    <div className="skills">
      <h2>Skills</h2>
      <div className="skills-group">
        {skillsT.map((skill) => {
          let classn = `skill ${skill.name}`
          return (
            <div
              className={classn}
              key={skill.name}  
            >
              {skill.icon}
              <h3>{skill.name}</h3>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default Skills;
